export const message = {
  saveFormPermissionSuccessMessage: 'Permission successfully saved',
  publishFormPermissionSuccessMessage: 'Permission successfully publish'
}